// src/features/organizationSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { organizationsApi } from '~/api/organizations-api';

// Define the slice state
interface OrganizationState {
  organization: any | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: OrganizationState = {
  organization: null,
  status: 'idle',
  error: null,
};

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch single organization by ID
      .addMatcher(organizationsApi.endpoints.getOrganizationById.matchPending, (state) => {
        state.status = 'loading';
      })
      .addMatcher(organizationsApi.endpoints.getOrganizationById.matchFulfilled, (state, action: any) => {
        state.status = 'succeeded';
        state.organization = action.payload?.response;
      })
      .addMatcher(organizationsApi.endpoints.getOrganizationById.matchRejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? 'Failed to fetch organization';
      })

      // Update organization
      .addMatcher(organizationsApi.endpoints.updateOrganization.matchPending, (state) => {
        state.status = 'loading';
      })
      .addMatcher(organizationsApi.endpoints.updateOrganization.matchFulfilled, (state, action: any) => {
        state.status = 'succeeded';
        state.organization = action.payload?.response ?? action.payload;
      })
      .addMatcher(organizationsApi.endpoints.updateOrganization.matchRejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? 'Failed to update organization';
      })

      // Create organization
      .addMatcher(organizationsApi.endpoints.createOrganization.matchPending, (state) => {
        state.status = 'loading';
      })
      .addMatcher(organizationsApi.endpoints.createOrganization.matchFulfilled, (state, action: any) => {
        state.status = 'succeeded';
        state.organization = action.payload?.response;
      })
      .addMatcher(organizationsApi.endpoints.createOrganization.matchRejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? 'Failed to create organization';
      });
  },
});

export default organizationSlice.reducer;
